/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Cancel_ErrorInputs */

const vi_stocktake_cancel_error = /** @type {(inputs: Stocktake_Cancel_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không hủy được phiếu`)
};

/**

* @param {Stocktake_Cancel_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_cancel_error = /** @type {((inputs?: Stocktake_Cancel_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Cancel_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_cancel_error(inputs)
});